module.exports = __webpack_public_path__ + "img/4_113.19a2eab2.png";